<rt-box layout-vertical>
  @if (title()) {
    <div class="form-description__title">{{ title() }}</div>
  }

  <!-- Security: This value is briefly sanitized by Recruitee/api -->
  @if (description()) {
    <div class="form-description__body" [innerHTML]="safeDescription()"></div>
  }
</rt-box>
